module.exports = __webpack_public_path__ + "static/media/4QPFa.e43f2de3.png";